import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { catchError, forkJoin, map, merge, Observable, of, startWith, switchMap } from 'rxjs';
import { AccountService } from 'src/app/private/services/account.service';
import { CompanyService } from 'src/app/private/services/company.service';
import { UsersService } from 'src/app/private/services/users.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import * as XLSX from 'xlsx';
import { TrackingService } from 'src/app/private/services/tracking.service';
import { applyCenterScopeToWhere } from 'src/app/utils/tenant-scope.util';
import {
  getAccountStatusBadgeClass,
  getAccountStatusLabel as formatAccountStatusLabel,
} from 'src/app/utils/status-badge.util';

import moment from 'moment';

@Component({
  selector: 'app-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.scss']
})
export class CompanyComponent implements AfterViewInit {

  searchQuery = new FormControl();
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;

  @ViewChild(MatSort)
  sort!: MatSort;

  dateQuery = new FormControl();
  center_id: any;
  totalRows = 0;
  temp: any = [];
  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  formAction = 'Add';
  currentPage = 0;
  pageSize = 25;
  pageSizeOptions: number[] = [10, 25, 100];
  btnLoading: boolean = false;
  reloading: boolean = false;
  initialLoad: boolean = false;
  closeResult = '';
  editData: any;
  deleteData: any;
  current_id_hover = '';
  infoArray: any = [];
  users: any = [];
  allLeadFields: any = [];
  loading: boolean = true;
  displayedColumns: string[] = [];

  uploadBtnLoading: boolean = false;


  isFixedColumn = true;


  importColumnsArray: any[] = [];
  exportColumns: string[] = [];
  exportColumnArrayObject: any[] = [];
  exportDataMap: any = {};
  filterArray: any[] = [];
  displayedLebel: any = {};
  renderColumns: string[] = [];

  exportArrayData: any[] = [];
  leadsRecord: any[] = [];
  isExportLoading: boolean = false;
  isLoading: boolean = false;

  isAdmin: boolean = false;

  /** First page from bootstrap — consumed once by loadData() to avoid duplicate getAllCompany. */
  private initialCompanyBootstrapResponse: any = null;
  private consumeInitialCompanyBootstrap = false;
  private sortCompanyPageResetBound = false;

  defaultFilter = [
    'account_name',
    'city',
    'state',
    'country',
    'postal_code',
    'email',
    'phone_number',
    'website',
    'industry',
    'status'
  ]

  info: any = [
    {
      key: 'account_name',
      value: 'Account Name'
    },
    {
      key: 'account_number',
      value: 'Account Number'
    },
    {
      key: 'description',
      value: 'Description'
    },
    {
      key: 'Owner',
      value: 'Account Owner'
    },
    {
      key: 'account_site',
      value: 'Account Site'
    },
    {
      key: 'account_type',
      value: 'Account Type'
    },
    {
      key: 'annual_revenue',
      value: 'Annual Revenue'
    },
    {
      key: 'employees',
      value: 'Employees'
    },
    {
      key: 'gst_no',
      value: 'GST No'
    },
    {
      key: 'tan_no',
      value: 'TAN No'
    },
    {
      key: 'ownership',
      value: 'Ownership'
    },
    {
      key: 'industry',
      value: 'Industry'
    },
    {
      key: 'rating',
      value: 'Rating'
    },
    {
      key: 'email',
      value: 'Email'
    },
    {
      key: 'phone_number',
      value: 'Phone Number'
    },
    {
      key: 'website',
      value: 'Website'
    },
    {
      key: 'status',
      value: 'Status'
    },
    {
      key: 'billing_address',
      value: 'Billing Address'
    },
    {
      key: 'shipping_address',
      value: 'Shipping Address'
    },
    {
      key: 'sic_code',
      value: 'SIC Code'
    },
    {
      key: 'ParentAccount',
      value: 'Parent Account'
    }
  ]

  constructor(
    private localStorage: LocalStorageService,
    private api: CompanyService,
    // private userApi: UsersService,
    private modalService: NgbModal,
    private toast: ToastrService,
    private userApi: UsersService,
    private apiService: AccountService,
    private tracker: TrackingService


  ) {
    this.isAdmin = this.localStorage.checkFullAccessForTableList(
      this.localStorage.getRole()
    );
  }

  ngOnInit(): void {
    this.getAllUsers();
  }


  private fetchCompanyListPage$(): Observable<any> {
    let param: any = {
      page: this.paginator.pageIndex * this.paginator.pageSize,
      limit: this.paginator.pageSize,
      filter: {},
      where: applyCenterScopeToWhere(
        { client_id: this.localStorage.getClientId() },
        this.localStorage
      ),
      order: {
        col: '"account"."updatedAt"',
        dir: 'DESC',
      },
    };

    if (this.searchQuery.value) {
      const key = Object.keys(this.searchQuery.value)[0];
      const value = this.searchQuery.value[key];
      const staticFilterFieds = [
        'account_name',
        'city',
        'state',
        'country',
        'postal_code',
        'email',
        'phone_number',
        'website',
        'industry',
        'status',
      ];
      if (staticFilterFieds.includes(key)) {
        param.filter = { staticFilter: { [key]: value } };
      } else {
        param.filter = { dynamicFilter: { [key]: value } };
      }
    }

    if (!this.isAdmin) {
      param.where.account_owner = this.localStorage.getUserId();
    }

    return this.api.getAllCompany(param).pipe(catchError(() => of(null)));
  }

  private applyCompanyRowsToTable(data: any): void {
    const rows = Array.isArray(data?.rows) ? data.rows : [];
    this.totalRows = data?.count ?? 0;
    this.dataSource = new MatTableDataSource<any>(rows);
    this.initialLoad = false;
    this.loading = false;
    this.reloading = false;
  }

  private bootstrapCompanyModule(): void {
    this.loading = true;
    const client_id = this.localStorage.getClientId();
    const fields$ = this.apiService.getAccountFields({ client_id }).pipe(
      catchError((err) => {
        console.error('getAccountFields failed', err);
        return of({ fields: [] as any[] });
      })
    );
    const rows$ = this.fetchCompanyListPage$().pipe(
      map((response: any) => {
        if (response === null) {
          return { rows: [], count: 0 };
        }
        return {
          rows: response?.rows ?? [],
          count: response?.count ?? 0,
        };
      }),
      catchError(() => of({ rows: [], count: 0 }))
    );

    forkJoin({ fields: fields$, rows: rows$ })
      .pipe(
        catchError((err) => {
          console.error('account bootstrap failed', err);
          return of({
            fields: { fields: [] as any[] },
            rows: { rows: [], count: 0 },
          });
        })
      )
      .subscribe({
        next: ({ fields, rows }) => {
          this.applyCompanyAccountFieldsLayout(fields);
          this.initialCompanyBootstrapResponse = rows;
          this.consumeInitialCompanyBootstrap = true;
          this.applyCompanyRowsToTable(rows);
          this.loadData();
        },
        error: (e) => {
          this.initialLoad = false;
          this.loading = false;
          this.toast.error('Something went wrong, please refresh the page');
          console.error(e);
        },
      });
  }

  ngAfterViewInit(): void {
    this.bootstrapCompanyModule();
  }

  private applyCompanyAccountFieldsLayout(data: any): void {
    this.filterArray = [];
    this.importColumnsArray = [];
    this.exportColumnArrayObject = [];
    this.exportColumns = [];
    this.exportDataMap = {};
    this.displayedLebel = {};
    this.infoArray = this.info.map((item: any) => ({ key: item.key, value: item.value }));
    this.displayedColumns = [];

    if (this.isFixedColumn) {
      this.displayedColumns = [
        "account_name",
        "info",
        // "account_number",
        "account_owner",
        // "account_site",
        // "account_type",
        // "annual_revenue",
        // "employees",
        "gst_no",
        // "tan_no",
        // "ownership",
        "industry",
        // "rating",
        "email",
        "phone_number",
        // "website",
        "status"
      ];

      this.displayedLebel['account_name'] = 'Account Name';
      this.displayedLebel['info'] = 'Info';
      this.displayedLebel['account_number'] = 'Account Number';
      this.displayedLebel['account_owner'] = 'Account Owner';
      this.displayedLebel['account_site'] = 'Account Site';
      this.displayedLebel['account_type'] = 'Account Type';
      this.displayedLebel['annual_revenue'] = 'Annual Revenue';
      this.displayedLebel['employees'] = 'Employees';
      this.displayedLebel['gst_no'] = 'GST No';
      this.displayedLebel['tan_no'] = 'TAN No';
      this.displayedLebel['ownership'] = 'Ownership';
      this.displayedLebel['industry'] = 'Industry';
      this.displayedLebel['rating'] = 'Rating';
      this.displayedLebel['email'] = 'Email';
      this.displayedLebel['phone_number'] = 'Phone Number';
      this.displayedLebel['website'] = 'Website';
      this.displayedLebel['status'] = 'Status';
      this.displayedLebel['action'] = 'Action';

    }

    const rawFields = data?.fields;
    this.allLeadFields = Array.isArray(rawFields)
      ? [...rawFields].sort((a: any, b: any) => (a.sequence ?? 0) - (b.sequence ?? 0))
      : [];

    if (this.isFixedColumn) {

      // to show on import screen 
      this.importColumnsArray = [
        // { key: 'account_owner', value: 'Account Owner' },
        { key: 'account_site', value: 'Account Site' },
        { key: 'account_name', value: 'Account Name' },
        { key: 'status', value: 'Status' },
        { key: 'account_number', value: 'Account Number' },
        { key: 'email', value: 'Email' },
        { key: 'account_type', value: 'Account Type' },
        { key: 'billing_address.city', value: 'Billing City' },
        { key: 'shipping_address.city', value: 'Shipping City' },
        { key: 'billing_address.state', value: 'Billing State' },
        { key: 'shipping_address.state', value: 'Shipping State' },
        { key: 'billing_address.postal_code', value: 'Billing Postal Code' },
        { key: 'shipping_address.postal_code', value: 'Shipping Postal Code' },
        { key: 'billing_address.country', value: 'Billing Country' },
        { key: 'shipping_address.country', value: 'Shipping Country' },
        { key: 'billing_address.street', value: 'Billing Street' },
        { key: 'shipping_address.street', value: 'Shipping Street' },
        { key: 'description', value: 'Description' },
        { key: 'ownership', value: 'Ownership' },
        { key: 'employees', value: 'Employees' },
        { key: 'sic_code', value: 'SIC Code' },
        { key: 'gst_no', value: 'GST No' },
        { key: 'tan_no', value: 'TAN No' },
        { key: 'annual_revenue', value: 'Annual Revenue' },
        { key: 'rating', value: 'Rating' },
        { key: 'fax', value: 'Fax' },
        { key: 'industry', value: 'Industry' },
        { key: 'website', value: 'Website' },
        { key: 'phone_number', value: 'Phone Number' },
      ];



      this.exportColumnArrayObject.push({ key: 'contact_name', value: 'Contact Name' })
      this.exportColumnArrayObject.push({ key: 'contact_email', value: 'Contact Email' })
      this.exportColumnArrayObject.push({ key: 'contact_phone', value: 'Contact Phone' })
      this.exportColumnArrayObject.push({ key: 'company_name', value: 'Organization' })
      this.exportColumnArrayObject.push({ key: 'lead_source', value: 'Lead Source' })


      this.filterArray.push({ key: 'account_name', value: 'Account Name' });
      this.filterArray.push({ key: 'city', value: 'City' });
      this.filterArray.push({ key: 'state', value: 'State' });
      this.filterArray.push({ key: 'country', value: 'Country' });
      this.filterArray.push({ key: 'email', value: 'Email' });
      this.filterArray.push({ key: 'phone_number', value: 'Phone Number' });
      this.filterArray.push({ key: 'website', value: 'Website' });
      this.filterArray.push({ key: 'industry', value: 'Industry' });
      this.filterArray.push({ key: 'status', value: 'Status' });



      this.exportColumns.push('Account Site');
      this.exportColumns.push('Account Name');
      this.exportColumns.push('Status');
      this.exportColumns.push('Account Number');
      this.exportColumns.push('Email');
      this.exportColumns.push('Account Type');
      this.exportColumns.push('Billing City');
      this.exportColumns.push('Shipping City');
      this.exportColumns.push('Billing State');
      this.exportColumns.push('Shipping State');
      this.exportColumns.push('Billing Postal Code');
      this.exportColumns.push('Shipping Postal Code');
      this.exportColumns.push('Billing Country');
      this.exportColumns.push('Shipping Country');
      this.exportColumns.push('Billing Street');
      this.exportColumns.push('Shipping Street');
      this.exportColumns.push('Description');
      this.exportColumns.push('Ownership');
      this.exportColumns.push('Employees');
      this.exportColumns.push('SIC Code');
      this.exportColumns.push('GST No');
      this.exportColumns.push('TAN No');
      this.exportColumns.push('Annual Revenue');
      this.exportColumns.push('Rating');
      this.exportColumns.push('Fax');
      this.exportColumns.push('Industry');
      this.exportColumns.push('Website');
      this.exportColumns.push('Phone Number');




      this.exportDataMap['Account Site'] = 'account_site';
      this.exportDataMap['Account Name'] = 'account_name';
      this.exportDataMap['Status'] = 'status';
      this.exportDataMap['Account Number'] = 'account_number';
      this.exportDataMap['Email'] = 'email';
      this.exportDataMap['Account Type'] = 'account_type';
      this.exportDataMap['Billing City'] = 'billing_address.city';
      this.exportDataMap['Shipping City'] = 'shipping_address.city';
      this.exportDataMap['Billing State'] = 'billing_address.state';
      this.exportDataMap['Shipping State'] = 'shipping_address.state';
      this.exportDataMap['Billing Postal Code'] = 'billing_address.postal_code';
      this.exportDataMap['Shipping Postal Code'] = 'shipping_address.postal_code';
      this.exportDataMap['Billing Country'] = 'billing_address.country';
      this.exportDataMap['Shipping Country'] = 'shipping_address.country';
      this.exportDataMap['Billing Street'] = 'billing_address.street';
      this.exportDataMap['Shipping Street'] = 'shipping_address.street';
      this.exportDataMap['Description'] = 'description';
      this.exportDataMap['Ownership'] = 'ownership';
      this.exportDataMap['Employees'] = 'employees';
      this.exportDataMap['SIC Code'] = 'sic_code';
      this.exportDataMap['GST No'] = 'gst_no';
      this.exportDataMap['TAN No'] = 'tan_no';
      this.exportDataMap['Annual Revenue'] = 'annual_revenue';
      this.exportDataMap['Rating'] = 'rating';
      this.exportDataMap['Fax'] = 'fax';
      this.exportDataMap['Industry'] = 'industry';
      this.exportDataMap['Website'] = 'website';
      this.exportDataMap['Phone Number'] = 'phone_number';
    }


    data?.fields?.forEach((element: any) => {

      this.infoArray.push({ key: element.field_name, value: element.label });

      if (element.isVisibleTable == 'true') {
        this.displayedColumns.push(element.field_name);
      }

      this.displayedLebel[element.field_name] = element.label;
      console.log('element.field_name', element)
      if (element.type == 'text') {
        this.filterArray.push({
          key: element.field_name,
          value: element.label
        });
      }



      this.importColumnsArray.push({ key: element.field_name, value: element.label });

      this.exportColumnArrayObject.push({ key: element.field_name, value: element.label })
    });

    // this.exportColumns = [];
    // this.exportDataMap = {};


    data?.fields?.forEach((element: any) => {
      this.exportColumns.push(element.label);
      this.exportDataMap[element.label] = element.field_name;
    });


    // fixed colums irrespective of fixed column





    // this.exportColumns.push('Lead Date');
    // this.exportColumns.push('Lead Time');
    // this.exportColumns.push('Lead Type');
    // this.exportColumns.push('Lead Status');
    // this.exportColumns.push('Assign To');


    this.exportColumnArrayObject.push({ key: 'lead_date', value: 'Lead Date' })
    this.exportColumnArrayObject.push({ key: 'lead_time', value: 'Lead Time' })
    this.exportColumnArrayObject.push({ key: 'lead_type', value: 'Lead Type' })
    this.exportColumnArrayObject.push({ key: 'lead_status', value: 'Lead Status' })
    this.exportColumnArrayObject.push({ key: 'assign_to', value: 'Assign To' })



    this.exportDataMap['Lead Date'] = 'lead_date';
    this.exportDataMap['Lead Time'] = 'lead_time';
    this.exportDataMap['Lead Type'] = 'lead_type';
    this.exportDataMap['Lead Status'] = 'lead_status';
    this.exportDataMap['Assign To'] = 'assign_to';

    this.displayedColumns.push('action');
    this.renderColumns = this.displayedColumns;
    this.loading = false;

    // action column
  }

  getAllContactFields() {
    this.loading = true;
    this.apiService.getAccountFields({ client_id: this.localStorage.getClientId() }).subscribe({
      next: (data) => this.applyCompanyAccountFieldsLayout(data),
      error: (e) => {
        this.loading = false;
        this.initialLoad = false;
        this.toast.error('Something went wrong, please refresh the page');
        console.error(e);
      },
    });
  }



  getAllUsers() {
    let param = {
      client_id: this.localStorage.getClientId(),
    };
    this.userApi.findAllUsers(param).subscribe({
      next: (res: any) => {
        this.users = res || [];
      },
      error: (e: any) => {
        console.error(e);
      },
    });
  }




  open(content: any) {
    this.formAction = 'Add';

    this.modalService.open(content, {
      size: 'xl', scrollable: true,
      centered: true
    })
  }

  getAccountStatusClass(status?: string | null): string {
    return getAccountStatusBadgeClass(status);
  }

  getAccountStatusLabel(status?: string | null): string {
    return formatAccountStatusLabel(status);
  }

  getCellValue(element: any, it: string): any {
    switch (it) {
      case "account_name":
        return element.account_name || 'N/A';
      case "account_number":
        return element.account_number || 'N/A';
      case "description":
        return element.description || 'N/A';
      case "account_owner":
        return this.getAccountOwner(element?.accountOwner)
      case "account_site":
        return element.account_site || 'N/A';
      case "account_type":
        return element.account_type || 'N/A';
      case "annual_revenue":
        return element.annual_revenue || 'N/A';
      case "employees":
        return element.employees || 'N/A';
      case "gst_no":
        return element.gst_no || 'N/A';
      case "tan_no":
        return element.tan_no || 'N/A';
      case "ownership":
        return element.ownership || 'N/A';
      case "industry":
        return element.industry || 'N/A';
      case "rating":
        return element.rating || 'N/A';
      case "email":
        return element.email || 'N/A';
      case "phone_number":
        return element.phone_number || 'N/A';
      case "website":
        return element.website ? `<a href="${element.website}" target="_blank">${element.website}</a>` : 'N/A';
      default:
        return this.checkNull(element, it);
    }
  }

  checkNull(data: any, col: any) {

    let row = ""
    try {
      if (data['fields'][col] != null) {
        row = data['fields'][col] || 'N/A';
        // console.log("--->",data['fields'][col])
      } else {
        row = 'N/A';
      }
    }
    catch (err) {

    }


    return row || 'N/A';
  }



  loadData() {

    try {
      if (!this.sortCompanyPageResetBound && this.sort) {
        this.sortCompanyPageResetBound = true;
        this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
      }
      merge(
        this.dateQuery.valueChanges,
        this.searchQuery.valueChanges,
        this.sort.sortChange,
        this.paginator.page
      )
        .pipe(
          startWith({}),
          switchMap(() => {
            if (
              this.consumeInitialCompanyBootstrap &&
              this.initialCompanyBootstrapResponse != null
            ) {
              this.consumeInitialCompanyBootstrap = false;
              const cached = this.initialCompanyBootstrapResponse;
              this.initialCompanyBootstrapResponse = null;
              return of(cached);
            }
            this.reloading = true;
            return this.fetchCompanyListPage$();
          }),
          map((response: any) => {
            this.initialLoad = false;
            this.reloading = false;
            if (response === null) {
              this.totalRows = 0;
              return [];
            }
            this.totalRows = response.count ?? 0;
            return response?.rows ?? [];
          })
        )
        .subscribe({
          next: (data) => {
            this.dataSource = new MatTableDataSource<any>(data);
          },
          error: (e) => {
            this.initialLoad = false;
            this.reloading = false;
            console.error(e);
          },
          complete: () => {
            this.initialLoad = false;
            this.reloading = false;
          },
        });
    } catch (e) {
      this.initialLoad = false;
      this.reloading = false;
      console.error(e);
    }
  }

  reloadData() {
    this.reloading = true;
    try {
      merge()
        .pipe(
          startWith({}),
          switchMap(() => {
            console.log("client_id", this.localStorage.getClientId())
            let param: any = {
              "page": this.paginator.pageIndex * this.paginator.pageSize,
              "limit": this.paginator.pageSize,
              "filter": {},
              where: applyCenterScopeToWhere(
                { client_id: this.localStorage.getClientId() },
                this.localStorage
              ),
              "order": {
                "col": "\"account\".\"updatedAt\"",
                "dir": "DESC"
              }
            }

            if (this.searchQuery.value) {

              for (let [key, value] of Object.entries(this.searchQuery.value)) {

                if (this.defaultFilter.includes(key)) {
                  key = (key == 'assign_to') ? 'assign_to' : key
                  const obj = {
                    ...param.filter,
                    [key]: value,
                  };
                  param.filter = obj;
                }
              }

            }


            return this.api
              .getAllCompany(param)
              .pipe(catchError(() => of(null)));
          }),
          map((response: any) => {
            this.initialLoad = false;
            if (response === null) {
              return [];
            }
            this.totalRows = response.count;
            console.log("response", response.length)
            return response?.rows;
          })
        )
        .subscribe({
          next: (data) => {
            this.dataSource = new MatTableDataSource<any>(data);
          },
          error: (e) => {
            this.initialLoad = false;
            this.reloading = false;
            console.error(e);
          },
          complete: () => {
            this.initialLoad = false;
            this.reloading = false;
          },
        });
    } catch (e) {
      this.initialLoad = false;
      this.reloading = false;
      console.error(e);
    }
  }


  export(header: any) {


    this.exportArrayData = [];
    let param: any = {
      where: applyCenterScopeToWhere(
        { client_id: this.localStorage.getClientId() },
        this.localStorage
      ),
    };
    this.isExportLoading = true;

    if (!this.isAdmin) {
      param.where.account_owner = this.localStorage.getUserId();
    }

    this.api.getAllAccount(param).subscribe({
      next: (data) => {
        this.isExportLoading = false;
        this.leadsRecord = data || [];
        this.isLoading = false;



        if (data.length > 0) {
          data.forEach((elem: any) => {
            const obj = {
              ...elem.fields,
              ...elem,
              assign_to:
                elem.user == null
                  ? ''
                  : elem.user.prefix +
                  ' ' +
                  elem.user.fname +
                  ' ' +
                  elem.user.lname,
            };
            this.exportArrayData.push(obj);
          });
        }

        let exportColumns = header.map((item: any) => {
          return item.value
        });

        const columnMapping = this.exportColumnArrayObject.reduce((map: any, col: any) => {
          map[col.value] = col.key;
          return map;
        }, {});


        console.log("exportColumns", exportColumns);
        console.log("exportDataMap", this.exportDataMap);
        exportColumns.map((col: any) => {
          console.log(this.exportDataMap[col], col);
        });

        // Step 2: Filter and map exportColumns to their corresponding display names
        const selectedColumns = exportColumns.map((key: any) => ({
          key: this.exportDataMap[key] || key, // Use the exportDataMap to get the key
          displayName: key // Fallback to the key if no mapping is found
        }));

        console.log("selectedColumns", selectedColumns);
        // Step 3: Generate Excel headers based on selected columns
        // const excelHeader = selectedColumns.map((col:any) => col.displayName);
        const excelHeader = [...new Set(selectedColumns.map((col: any) => col.displayName))];

        // Step 4: Prepare Excel data dynamically
        console.log("exportArrayData", this.exportArrayData);
        const excelData = this.exportArrayData.map((lead: any) => {
          const row: any = {};
          selectedColumns.forEach((col: any) => {

            console.log("col", col);
            // Use the mapped key to access the lead dat
            console.log("lead[col.key]", lead[col.key]);
            row[col.displayName] = lead[col.key] || ''; // Use mapped display name as key

            if (col.key === 'billing_address.city' || col.key === 'billing_address.state' || col.key === 'billing_address.postal_code' || col.key === 'billing_address.country' || col.key === 'billing_address.street') {
              if (col.key === 'billing_address.street') {
                row[col.displayName] = lead.billing_address?.street || '';
              }

              if (col.key === 'billing_address.city') {
                row[col.displayName] = lead.billing_address?.city || '';
              }

              if (col.key === 'billing_address.state') {
                row[col.displayName] = lead.billing_address?.state || '';
              }

              if (col.key === 'billing_address.postal_code') {
                row[col.displayName] = lead.billing_address?.postal_code || '';
              }

              if (col.key === 'billing_address.country') {
                row[col.displayName] = lead.billing_address?.country || '';
              }


            }

            if (col.key === 'shipping_address.city' || col.key === 'shipping_address.state' || col.key === 'shipping_address.postal_code' || col.key === 'shipping_address.country' || col.key === 'shipping_address.street') {
              if (col.key === 'shipping_address.street') {
                row[col.displayName] = lead.shipping_address?.street || '';
              }

              if (col.key === 'shipping_address.city') {
                row[col.displayName] = lead.shipping_address?.city || '';
              }

              if (col.key === 'shipping_address.state') {
                row[col.displayName] = lead.shipping_address?.state || '';
              }

              if (col.key === 'shipping_address.postal_code') {
                row[col.displayName] = lead.shipping_address?.postal_code || '';
              }

              if (col.key === 'shipping_address.country') {
                row[col.displayName] = lead.shipping_address?.country || '';
              }
            }
          });
          return row;
        });


        // Step 5: Create workbook and worksheet
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);

        // Add headers and data to worksheet
        XLSX.utils.sheet_add_aoa(ws, [excelHeader]); // Add header row
        XLSX.utils.sheet_add_json(ws, excelData, {
          origin: 'A2', // Start from the second row
          skipHeader: true,
        });

        // Append worksheet to workbook
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

        // Step 6: Generate file name with timestamp
        const date = new Date();
        const fileName = `Account_data_${date.getDate()}_${date.getMonth() + 1}_${date.getFullYear()}_${date.getTime()}.xlsx`;

        // Step 7: Write the workbook to a file
        XLSX.writeFile(wb, fileName);
        const desc = `Account list exported with ${this.exportArrayData.length} records`;
        this.tracker.track("Export", "Account", desc);

      },
      error: (e) => {
        this.isExportLoading = false;
        this.isLoading = false;
      },
    });
  }

  openEdit(content: any, data: any) {
    this.formAction = 'Update';
    this.editData = data;
    this.modalService.open(content, {
      size: 'lg', scrollable: true,
      centered: true
    })
  }

  openDeleteEvent(content: any, data: any) {
    this.deleteData = data;
    this.modalService.open(content, {
      size: 'md', scrollable: true,
      centered: true
    })
  }

  searchFilter(query: any) {
    console.log('Search Query:', query);
    this.searchQuery.setValue(query);
  }

  handleDeleteCompany() {

    const parmas = {
      account_id: this.deleteData.account_id
    }
    this.btnLoading = true;
    this.api.deleteCompany(parmas).subscribe((res: any) => {
      console.log('Response:', res);
      this.toast.success('Account Deleted Successfully');
      const desc = `Account deleted with name: ${this.deleteData.account_name}, ID: ${this.deleteData.account_id}`;
      this.tracker.track("Delete", "Account", desc);
      this.reloadData();
      this.btnLoading = false;
      this.modalService.dismissAll();
    })
  }

  updateHoverState(id: string): void {
    this.current_id_hover = id;
  }

  getAccountOwner(user: any) {
    const name = [user?.fname, user?.lname].filter(Boolean).join(' ');

    if (name) {
      return name;
    } else {
      return 'N/A';
    }
  }



  importData(event: any) {
    if (event.length > 0) {
      this.uploadBtnLoading = true
      this.api.createBulkAccount(event).subscribe({
        next: (res) => {
          if (res) {
            this.uploadBtnLoading = false
            this.toast.success("Data uploaded Successfully")
            this.modalService.dismissAll()
            this.reloadData();
            const desc = `Account data imported with ${event.length} records`; // ✅ Log message
            this.tracker.track("Import", "Account", desc); // ✅ Tracker log
          }
        },
        error: (e) => {
          this.uploadBtnLoading = false
        }
      })
    }
    else {

      this.toast.error("Please Upload Data")
    }
    console.log(event)
  }


}
